import { addMessages } from '@hana/i18n';

// Khoá chuỗi cdt.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'cdt.1': "Thử lại",
  'cdt.2': "Mã phí",
  'cdt.3': "Đối tác",
  'cdt.4': "Dòng",
  'cdt.5': "C.từ",
  'cdt.6': "Tất cả dòng mua đã khớp",
  'cdt.7': "Dự kiến",
  'cdt.8': "Thực tế",
  'cdt.9': "Bán · debit khách",
  'cdt.10': "Mua · đối tác",
  'cdt.11': "Bên trả",
  'cdt.12': "Tệ",
  'cdt.13': "HĐ",
  'cdt.14': "Lãi dòng",
  'cdt.15': "Cờ",
  'cdt.16': "Tổng",
  'cdt.17': "Không có cảnh báo",
  'cdt.18': "Khoá",
  'cdt.19': "Sửa sau duyệt",
  'cdt.20': "Lỗ · không chia",
});
addMessages('en', {
  'cdt.1': "Retry",
  'cdt.2': "Fee code",
  'cdt.3': "Partner",
  'cdt.4': "Lines",
  'cdt.5': "Docs",
  'cdt.6': "All purchase lines matched",
  'cdt.7': "Planned",
  'cdt.8': "Actual",
  'cdt.9': "Sell · customer debit",
  'cdt.10': "Buy · partner",
  'cdt.11': "Payer",
  'cdt.12': "Curr.",
  'cdt.13': "Invoice",
  'cdt.14': "Line margin",
  'cdt.15': "Flags",
  'cdt.16': "Total",
  'cdt.17': "No alerts",
  'cdt.18': "Lock",
  'cdt.19': "Edit after approval",
  'cdt.20': "Loss · not split",
});
